import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const FETCH_REPORT_REQUEST = "FETCH_REPORT_REQUEST";
export const FETCH_REPORT_SUCCESS = "FETCH_REPORT_SUCCESS";
export const FETCH_REPORT_FAILURE = "FETCH_REPORT_FAILURE";

export const fetchAttendanceReport = (params = {}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_REPORT_REQUEST });
    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(`${BASE_URL}/v1/api/admin/attendanceReport`, {
        headers: { authorization: token },
        params: params, 
      });

      dispatch({
        type: FETCH_REPORT_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      const msg = error.response?.data?.meta?.message || "Failed to fetch report";
      dispatch({ type: FETCH_REPORT_FAILURE, payload: msg });
      toast.error(msg);
    }
  };
};